export default {
  path: '/usuarios',
  component: () => import('@/components/views/Users')
}
